import { DropPoint as _DropPoint } from '@team-milva/lab-models/resources'

export class DropPoint extends _DropPoint {
  getName(locale: string): string {
    return (
      this.name[locale] ||
      this.name['en'] ||
      Object.values(this.name).find((v) => v) ||
      ''
    )
  }

  getPlacement(locale: string): string {
    return (
      this.placement[locale] ||
      this.placement['en'] ||
      Object.values(this.placement).find((v) => v) ||
      ''
    )
  }
}
